import { useRef } from "react"
import * as Slider from "@radix-ui/react-slider"
import useComponentSize from "@rehooks/component-size"

import { cn } from "@/domains/library"
import { clamp } from "@/lib/clamp"

type VoteSliderProps = {
  initialValue: number
  minWeeks: number
  trackRangeBg?: string
  onChange: (value: number) => void
}

type SliderTick = {
  desktopLabel: string
  desktopTickPosition: number
  desktopShiftTextLeft: number
  mobileTickPosition: number
  mobileLabel?: string
  mobileShiftTextLeft: number
  hideOnMobile?: boolean
  clickValue: number
}

const ticks: SliderTick[] = [
  {
    desktopLabel: "1",
    desktopTickPosition: 1,
    desktopShiftTextLeft: 0,
    mobileTickPosition: 2,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: false,
    clickValue: 1,
  },
  {
    desktopLabel: "2",
    desktopTickPosition: 4.88,
    desktopShiftTextLeft: 2,
    mobileTickPosition: 5.8,
    mobileLabel: undefined,
    mobileShiftTextLeft: 2,
    hideOnMobile: true,
    clickValue: 2,
  },
  {
    desktopLabel: "3",
    desktopTickPosition: 8.76,
    desktopShiftTextLeft: 2,
    mobileTickPosition: 9.6,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 3,
  },
  {
    desktopLabel: "4",
    desktopTickPosition: 12.64,
    desktopShiftTextLeft: 2,
    mobileTickPosition: 13.4,
    mobileLabel: undefined,
    mobileShiftTextLeft: 2,
    hideOnMobile: true,
    clickValue: 4,
  },
  {
    desktopLabel: "5",
    desktopTickPosition: 16.52,
    desktopShiftTextLeft: 2,
    mobileTickPosition: 17.2,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 5,
  },
  {
    desktopLabel: "6",
    desktopTickPosition: 20.4,
    desktopShiftTextLeft: 2,
    mobileTickPosition: 21.2,
    mobileLabel: undefined,
    mobileShiftTextLeft: 1,
    hideOnMobile: false,
    clickValue: 6,
  },
  {
    desktopLabel: "7",
    desktopTickPosition: 24.28,
    desktopShiftTextLeft: 2,
    mobileTickPosition: 24.8,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 7,
  },
  {
    desktopLabel: "8",
    desktopTickPosition: 28.16,
    desktopShiftTextLeft: 2,
    mobileTickPosition: 28.6,
    mobileLabel: undefined,
    mobileShiftTextLeft: 2,
    hideOnMobile: true,
    clickValue: 8,
  },
  {
    desktopLabel: "9",
    desktopTickPosition: 32.04,
    desktopShiftTextLeft: 2,
    mobileTickPosition: 32.4,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 9,
  },
  {
    desktopLabel: "10",
    desktopTickPosition: 35.92,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 36.2,
    mobileLabel: undefined,
    mobileShiftTextLeft: 3,
    hideOnMobile: true,
    clickValue: 10,
  },
  {
    desktopLabel: "11",
    desktopTickPosition: 39.8,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 40,
    mobileLabel: undefined,
    mobileShiftTextLeft: 2,
    hideOnMobile: false,
    clickValue: 11,
  },
  {
    desktopLabel: "12",
    desktopTickPosition: 43.68,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 43.8,
    mobileLabel: undefined,
    mobileShiftTextLeft: 3,
    hideOnMobile: true,
    clickValue: 12,
  },
  {
    desktopLabel: "13",
    desktopTickPosition: 47.56,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 47.6,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 13,
  },
  {
    desktopLabel: "14",
    desktopTickPosition: 51.44,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 51.4,
    mobileLabel: undefined,
    mobileShiftTextLeft: 3,
    hideOnMobile: true,
    clickValue: 14,
  },
  {
    desktopLabel: "15",
    desktopTickPosition: 55.32,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 55.2,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 15,
  },
  {
    desktopLabel: "16",
    desktopTickPosition: 59.2,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 59,
    mobileLabel: undefined,
    mobileShiftTextLeft: 3,
    hideOnMobile: false,
    clickValue: 16,
  },
  {
    desktopLabel: "17",
    desktopTickPosition: 63.08,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 62.8,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 17,
  },
  {
    desktopLabel: "18",
    desktopTickPosition: 66.96,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 66.6,
    mobileLabel: undefined,
    mobileShiftTextLeft: 3,
    hideOnMobile: true,
    clickValue: 18,
  },
  {
    desktopLabel: "19",
    desktopTickPosition: 70.84,
    desktopShiftTextLeft: 3,
    mobileTickPosition: 70.4,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 19,
  },
  {
    desktopLabel: "20",
    desktopTickPosition: 74.72,
    desktopShiftTextLeft: 5,
    mobileTickPosition: 74.2,
    mobileLabel: undefined,
    mobileShiftTextLeft: 5,
    hideOnMobile: true,
    clickValue: 20,
  },
  {
    desktopLabel: "21",
    desktopTickPosition: 78.6,
    desktopShiftTextLeft: 5,
    mobileTickPosition: 77.7,
    mobileLabel: undefined,
    mobileShiftTextLeft: 4,
    hideOnMobile: false,
    clickValue: 21,
  },
  {
    desktopLabel: "22",
    desktopTickPosition: 82.48,
    desktopShiftTextLeft: 5,
    mobileTickPosition: 81.8,
    mobileLabel: undefined,
    mobileShiftTextLeft: 5,
    hideOnMobile: true,
    clickValue: 22,
  },
  {
    desktopLabel: "23",
    desktopTickPosition: 86.36,
    desktopShiftTextLeft: 5,
    mobileTickPosition: 85.6,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 23,
  },
  {
    desktopLabel: "24",
    desktopTickPosition: 90.24,
    desktopShiftTextLeft: 5,
    mobileTickPosition: 89.4,
    mobileLabel: undefined,
    mobileShiftTextLeft: 5,
    hideOnMobile: true,
    clickValue: 24,
  },
  {
    desktopLabel: "25",
    desktopTickPosition: 94.12,
    desktopShiftTextLeft: 5,
    mobileTickPosition: 93.2,
    mobileLabel: undefined,
    mobileShiftTextLeft: 0,
    hideOnMobile: true,
    clickValue: 25,
  },
  {
    desktopLabel: "26",
    desktopTickPosition: 98,
    desktopShiftTextLeft: 4,
    mobileTickPosition: 96.7,
    mobileLabel: "26",
    mobileShiftTextLeft: 4,
    hideOnMobile: false,
    clickValue: 26,
  },
]

export const EpochSlider = ({ initialValue, onChange, minWeeks = 0, trackRangeBg }: VoteSliderProps) => {
  const ref = useRef<HTMLDivElement>(null)

  const { width } = useComponentSize(ref)

  const hideOnMobileWidth = 360
  const isMobileView = width < hideOnMobileWidth

  const onValueChange = (incomingValue: Array<number>) => {
    if (incomingValue.length > 0) {
      onChange(Number(incomingValue[0]))
    }
  }

  return (
    <div className="relative min-w-[112px]" ref={ref}>
      {ticks.map((tick) => {
        const isTickInPast = tick.clickValue < minWeeks
        return (
          <div
            key={`tick-label-${tick.desktopLabel}`}
            className={cn(
              "absolute top-[32px] z-10 text-[10px] hover:cursor-pointer group-focus-within:text-primary",
              tick.hideOnMobile && isMobileView ? "hidden" : "",
              isTickInPast ? "text-secondary-600" : "text-t300-shade",
            )}
            style={{
              left: `calc(${isMobileView ? tick.mobileTickPosition : tick.desktopTickPosition}% - ${
                isMobileView ? tick.mobileShiftTextLeft : tick.desktopShiftTextLeft
              }px)`,
            }}
            onClick={(event) => {
              event.stopPropagation()
              event.nativeEvent.stopImmediatePropagation()
              onChange(tick.clickValue)
            }}
          >
            {isMobileView && tick.mobileLabel ? tick.mobileLabel : tick.desktopLabel}
          </div>
        )
      })}

      <Slider.Root
        className="slider-root group relative flex h-[20px] min-w-[120px] touch-none select-none items-center"
        defaultValue={[clamp(initialValue, minWeeks, 26)]}
        min={1}
        max={26}
        step={1}
        aria-label="Vote"
        value={[initialValue]}
        onValueChange={onValueChange}
      >
        {ticks.map((tick) => {
          const isTickInPast = tick.clickValue < minWeeks
          return (
            <div
              key={`tick-${tick.desktopLabel}`}
              className={cn(
                "absolute right-[1%] top-[16px] text-[12px]  ",
                tick.hideOnMobile && isMobileView ? "hidden" : "",
                isTickInPast ? "text-secondary-600" : "text-t300-shade group-focus-within:text-t300",
              )}
              style={{
                left: `${isMobileView ? tick.mobileTickPosition : tick.desktopTickPosition}%`,
              }}
            >
              |
            </div>
          )
        })}
        <Slider.Track className="slider-track relative h-[8px] flex-grow rounded-full bg-p400">
          <Slider.Range
            className={cn("slider-range absolute inset-0 h-full rounded-full", trackRangeBg ? trackRangeBg : "bg-p200")}
          />
        </Slider.Track>
        <Slider.Thumb className="slider-thumb relative flex h-4 w-4 flex-col items-center justify-center rounded-full bg-white text-center text-[10px] font-normal text-t100"></Slider.Thumb>
      </Slider.Root>
    </div>
  )
}
